/* eslint-disable prettier/prettier */
import { TranslationMap } from './default'

export const de: TranslationMap = {
  "accountstatus.Active": "Active",
  "accountstatus.Inactive": "Inactive",
  "accountstatus.Terminated": "Terminated",
  "additionalitems.title": "Additional items",
  "cart.addtocart": "Add to cart",
  "cart.addtocart.alreadyincart": "@@PRODUCT@@ is already in your cart",
  "cart.addtocart.currencylocked": "Your cart is currently set to @@CURRENCY@@. It is not possible to combine multiple currencies in one order. To purchase this product, please clear your @@SHOPPING_CART@@ first.",
  "cart.addtocart.locked": "Your cart currency has been set to @@CURRENCY@@ with the following ship-to location @@LOCATION@@",
  "cart.addtocart.shiptolocked": "Your shopping cart is already set to ship-to location\n\n@@LOCATION@@\n\nTo purchase this product, change the ship-to location in your @@SHOPPING_CART@@ first",
  "cart.addtocart.success": "@@PRODUCT@@ has been added to your cart",
  "cart.empty": "Your cart is currently empty",
  "cart.empty.title": "Your shopping cart is empty",
  "cart.gotoproductlist": "Go to product list",
  "cart.nolongervalid": "Your cart is invalid, please update it to continue",
  "cart.recalculate": "Recalculate",
  "cart.recalculate.rounding": "Requested amount was rounded up to fit the pack size.",
  "cart.removefromcart.success": "@@PRODUCT@@ has successfully been removed from your cart",
  "cart.removeproduct": "Are you sure you want to remove @@PRODUCT@@ from your shopping cart?",
  "cart.requestquote": "Request quote",
  "cart.updatecart": "Update",
  "cart.updatecart.success": "@@PRODUCT@@ has been updated in your cart",
  "dangerousgoodsclass.1": "Explosive (1)",
  "dangerousgoodsclass.2.1": "Flammable gas (2.1)",
  "dangerousgoodsclass.2.2": "Non-flammable gas (2.2)",
  "dangerousgoodsclass.2.3": "Toxic gas (2.3)",
  "dangerousgoodsclass.3": "Flammable liquid (3)",
  "dangerousgoodsclass.4.1": "Flammable solid (4.1)",
  "dangerousgoodsclass.4.2": "Flammable solid combustible (4.2)",
  "dangerousgoodsclass.4.3": "Dangerous when wet (4.3)",
  "dangerousgoodsclass.5.1": "Oxidizing (5.1)",
  "dangerousgoodsclass.6.1": "Toxic (6.1)",
  "dangerousgoodsclass.6.2": "Biohazard (6.2)",
  "dangerousgoodsclass.7": "Radioactive (7)",
  "dangerousgoodsclass.8": "Corrosive (8)",
  "dangerousgoodsclass.9": "Miscellaneous (9)",
  "date.invalid": "The selected date is invalid",
  "datefilteroption.last3Months": "Last 3 Months",
  "datefilteroption.lastMonth": "Last Month",
  "datefilteroption.lastWeek": "Last Week",
  "datefilteroption.lastYear": "Last Year",
  "field.duplicatedphonenumber": "Phone number already exists",
  "field.invalid": "@@VALUE@@ is invalid",
  "field.invalidinternalemail": "Email is invalid and must be provided by brenntag.com, brenntag-asia.com or digib.com",
  "field.invalidphonenumber": "Phone number is invalid, use format +61212345678",
  "field.required": "@@VALUE@@ is required",
  "filter.accessStatus": "Access status",
  "filter.all": "All",
  "filter.allorders": "All orders",
  "filter.allproducts": "All products",
  "filter.apply": "Apply",
  "filter.brenntagOrderNumber": "Brenntag order number",
  "filter.compliancerequired": "Compliance required",
  "filter.createddate": "Creation date",
  "filter.customerName": "Customer name",
  "filter.customerNumber": "Customer number",
  "filter.customerpo.placeholder": "Filter by customer PO number",
  "filter.customerponumber": "Customer PO number",
  "filter.dangerousgoods": "Dangerous goods",
  "filter.deliveryNumber": "Delivery number",
  "filter.deliverydate": "Requested delivery date",
  "filter.enddate": "End date",
  "filter.filterby": "Filter by",
  "filter.filters": "Filters",
  "filter.from": "from",
  "filter.hazardous": "Hazardous goods",
  "filter.invoicenumber": "Invoice number",
  "filter.lastlogindate": "Last login date",
  "filter.myorders": "My orders",
  "filter.myproducts": "My products",
  "filter.noresults": "No results found",
  "filter.orderdate": "Order date",
  "filter.otherfilters": "Other filters",
  "filter.pill.accessStatus": "Access status",
  "filter.pill.brenntagOrderNumber": "Brenntag Order #",
  "filter.pill.createdDate": "Creation date",
  "filter.pill.customerPONumber": "PO #",
  "filter.pill.dangerousGoods": "Dangerous goods",
  "filter.pill.deliveryDate": "Requested delivery date",
  "filter.pill.dueDate": "Due date",
  "filter.pill.hazardousGoods": "Hazardous goods",
  "filter.pill.invoiceNumber": "Invoice number",
  "filter.pill.issueDate": "Invoice date",
  "filter.pill.lastLoginDate": "Login date",
  "filter.pill.orderDate": "Order date",
  "filter.pill.packageType": "Pack type",
  "filter.pill.pricePointExists": "Products with pricing",
  "filter.pill.productName": "Product name",
  "filter.pill.productNumber": "Product number",
  "filter.pill.quoteDate": "Quote date",
  "filter.pill.requestedDeliveryDate": "Requested delivery",
  "filter.pill.resetAll": "Reset all filters",
  "filter.pill.role": "Role",
  "filter.pill.salesGroupId": "Sales organisation",
  "filter.pill.searchQuery": "Search",
  "filter.pill.shipToLocationId": "Ship to",
  "filter.pill.status": "Status",
  "filter.pill.updatedDate": "Updated date",
  "filter.pill.userName": "User",
  "filter.placeholder.customerName": "Search by customer name",
  "filter.placeholder.customerNumber": "Search by customer number",
  "filter.placeholder.global": "Search products, orders or invoices...",
  "filter.placeholder.userEmail": "Search by email",
  "filter.placeholder.username": "Search by name",
  "filter.pricePointExists": "Products with pricing",
  "filter.productName": "Product name",
  "filter.quoteNumber": "Quote number",
  "filter.quotedate": "Quote date",
  "filter.role": "Role",
  "filter.salesRepName": "Sales representative name",
  "filter.salesorganisation": "Sales organisation",
  "filter.search-salesorg.placeholder": "Search by customer or sales organisation",
  "filter.search.placeholder": "Search",
  "filter.shipto": "Ship-to",
  "filter.startdate": "Start date",
  "filter.status": "Status",
  "filter.until": "to",
  "filter.updated": "Updated",
  "filter.user": "User",
  "filter.userEmail": "Email",
  "filter.userName": "Name",
  "footer.contactus": "Kontakt",
  "footer.faqs": "FAQs",
  "footer.privacypolicy": "Data Protection and Privacy Statement",
  "footer.termsofuse": "Terms of Use",
  "home.contact.1": "Contact Brenntag Connect Team",
  "home.contact.2": "F.A.Q.",
  "home.heading.1": "Hello, @@USERNAME@@",
  "home.heading.2": "Welcome to Brenntag Connect!",
  "home.heading.3": "Brenntag Connect is your online platform for easy ordering of chemicals and accessing up-to-date information.",
  "home.heading.4": "Quick actions",
  "home.invoices.list.1": "View invoices",
  "home.invoices.list.2": "Download invoices PDFs",
  "home.label.explore": "Explore",
  "home.label.viewinvoices": "View all invoices",
  "home.label.vieworders": "View all orders",
  "home.orders.list.1": "View order history and status",
  "home.orders.list.2": "Download Certificate of Analysis",
  "home.products.list.1": "Search Brenntag catalog",
  "home.products.list.2": "View and download SDS/TDS documents",
  "home.products.list.3": "Order products",
  "home.profile.list.1": "Export invoices data",
  "home.profile.list.2": "Export orders data",
  "home.profile.list.3": "Reset password",
  "home.recent.invoices.due": "Recent invoices due",
  "home.recent.invoices.issued": "Recently issued invoices",
  "home.recent.orders.created": "Recently created orders",
  "home.recent.orders.updated": "Recently updated orders",
  "invoice.customer": "Customer",
  "invoice.date": "Date issued",
  "invoice.dueDate": "Invoice due date",
  "invoice.noinvoicesfound": "No invoices are available yet.\nWe issue invoices only after a complete order shipment.",
  "invoice.number": "Invoice number",
  "invoicestatus.Cancelled": "Cancelled",
  "invoicestatus.Open": "Open",
  "invoicestatus.Paid": "Paid",
  "invoicestatus.PaidOnline": "Paid online",
  "invoicestatus.ProcessingPayment": "Processing payment",
  "isolanguage.en": "English",
  "isolanguage.id": "Bahasa Indonesia",
  "isolanguage.ko": "한국어",
  "isolanguage.th": "ไทย",
  "isolanguage.vi": "Tiếng Việt",
  "isolanguage.zh-CN": "中文（簡體）",
  "isolanguage.zh-TW": "中文（繁體）",
  "label.Landline": "Landline",
  "label.Mobile": "Mobile",
  "label.additionalinformation": "Additional information",
  "label.addresses": "Addresses",
  "label.alternativesizes": "Alternative Sizes",
  "label.amountdue": "Amount due",
  "label.any": "Any",
  "label.anyquestions": "Any questions?",
  "label.batchamount": "Batch amount",
  "label.batchnumber": "Batch number",
  "label.batchsize": "Batch size",
  "label.billingaddress": "Billing address",
  "label.billtoaddress": "Bill-to address",
  "label.billtoaddresses": "Bill-to address(es)",
  "label.billtoaddressincorrect": "To change your address details, please contact us via Chat",
  "label.billtoaddressrequired": "Bill-to address is required",
  "label.brenntagordernumber": "Brenntag order number",
  "label.browseproducts": "Browse products",
  "label.browseusers": "Browse users",
  "label.button.attach": "Attach",
  "label.button.changesalesorg": "Yes, change Sales Organisations",
  "label.button.editprofile": "Edit My profile",
  "label.button.export": "Export",
  "label.button.nokeep": "No, Keep",
  "label.button.update": "Update",
  "label.button.yesterminate": "Yes, Terminate",
  "label.by": "by",
  "label.callus": "Call us",
  "label.cancel": "Cancel",
  "label.category": "Category",
  "label.changepassword": "Reset password",
  "label.changesalesorg": "Change Sales Organisations",
  "label.changesalesorgwarning": "Are you sure you want change Sales Organisations?",
  "label.checkingavailability": "Checking availability…",
  "label.clickheretoreview": "Click here to review our",
  "label.comments": "Comments",
  "label.company": "Company",
  "label.confirmeddeliveryamount": "Confirmed delivery amount",
  "label.continueshopping": "Continue shopping",
  "label.country": "Country",
  "label.creationdate": "Creation date",
  "label.creditnote": "Credit note",
  "label.customer": "Customer",
  "label.customername": "Customer name",
  "label.customernumber": "Customer number",
  "label.customerponumber": "Customer PO number",
  "label.customerporeference": "Customer PO reference",
  "label.customerporeferencemaxlength": "Customer PO reference cannot be longer than @@LENGTH@@ characters",
  "label.customerporeferencerequired": "Customer PO reference is required",
  "label.dangerousgoodsclass": "Dangerous goods class",
  "label.dangerousgoodscode": "DG",
  "label.datedelivered": "Delivery date",
  "label.datefrom": "Date from",
  "label.dateissued": "Date issued",
  "label.dateto": "Date to",
  "label.debitnote": "Debit note",
  "label.defaultlanguage": "Language",
  "label.delete": "Delete",
  "label.deliverynumber": "Delivery number",
  "label.details": "Details",
  "label.discountperpack": "Discount per pack",
  "label.distributionchannel": "Distribution channel",
  "label.division": "Division",
  "label.documents": "Download documents",
  "label.dontshowthis": "Do not show this again",
  "label.download.all": "Download all",
  "label.download.pdf": "Download PDF",
  "label.editmode": "edit mode",
  "label.email": "Email address",
  "label.emailaddress": "Email address",
  "label.exportdata": "Export data",
  "label.exporting": "Exporting data, it can take a moment...",
  "label.exportingerror": "Error exporting the file, please try again.",
  "label.exportinglonger": "Still generating the export. It might take a few moments.",
  "label.exportingsuccess": "Data file exported successfully.",
  "label.exportordersinvoicescsv": "Export structured data of your orders and invoices directly as CSV or Excel (XLSX) files.",
  "label.exportselectcategory": "Select a category and a date range for the export file.",
  "label.externaluserfile": "External user file",
  "label.filesattached": "files attached",
  "label.from": "From: ",
  "label.fullname": "Full name",
  "label.hazardousgoodscode": "HZ",
  "label.hazchem": "HazChem",
  "label.internaluserfile": "Internal user file",
  "label.invoice": "Invoice",
  "label.invoice.status.Cancelled": "Cancelled",
  "label.invoice.status.Open": "Open",
  "label.invoice.status.Paid": "Paid",
  "label.invoice.status.PaidOnline": "Paid online",
  "label.invoice.status.ProcessingPayment": "Processing payment",
  "label.item": "item",
  "label.items": "items",
  "label.language": "Language",
  "label.lastlogin": "Last login",
  "label.learn_more_about_brenntag": "Learn more about Brenntag Connect",
  "label.logout": "Log out",
  "label.minimumquantity": "Minimum quantity",
  "label.myprofile": "My profile",
  "label.name": "Full name",
  "label.next-step": "Next step",
  "label.no": "No",
  "label.no-filesattached": "No files attached",
  "label.no-filesuploaded": "No files uploaded",
  "label.none": "None",
  "label.nopriceavailable": "No price available",
  "label.notes": "Notes",
  "label.orderNumber": "Order number",
  "label.orderamount": "Order amount",
  "label.orderamount.zero": "Order amount can't be 0, you can remove a product at your cart.",
  "label.orderdate": "Order date",
  "label.orderdetails": "Order details",
  "label.orderfiles": "Order files",
  "label.orderlist": "Order list",
  "label.ordervalue": "Order value",
  "label.pack": "Pack",
  "label.packaging": "Packaging",
  "label.packaginginformation": "Packaging information",
  "label.packinggroup": "Packing group",
  "label.packsize": "Pack size",
  "label.packtype": "Pack type",
  "label.paymentreference": "Payment reference",
  "label.paymentterms": "Payment terms",
  "label.payonline": "Pay online",
  "label.personalinfo": "User information",
  "label.phonenumber": "Phone number",
  "label.placeorder": "Place order",
  "label.placingorder": "Placing order",
  "label.preferences": "Preferences",
  "label.previous-step": "Previous step",
  "label.price": "Pricing",
  "label.priceperpack": "Price per pack",
  "label.pricesareexclusiveofsurcharges": "Prices are exclusive of taxes and other surcharges that may apply.",
  "label.pricesaresubjecttochange": "Prices are subject to change.",
  "label.productname": "Product name",
  "label.productnumber": "Product number",
  "label.products": "Products",
  "label.producttype": "Product type",
  "label.profile": "Profile",
  "label.purchaseOrderNumber": "Customer PO number",
  "label.quantity": "Quantity",
  "label.quantity.minimumorderamount": "Amount must be greater than or equal to @@MINIMUMORDERAMOUNT@@",
  "label.quantity.minimumorderquantity": "Quantity must be greater than or equal to @@MINIMUMORDERQUANTITY@@",
  "label.quantity.tiereddiscounts": "Quantity discounts available",
  "label.quantity.toolarge": "Value is too large",
  "label.quantity.zero": "Value must be greater than 0",
  "label.quotedate": "Quote date",
  "label.quotenumber": "Quote number",
  "label.records": "items",
  "label.redirecttoadmin": "Go to administration interface",
  "label.remove": "Remove",
  "label.removeproduct": "Remove product",
  "label.reorder": "Reorder",
  "label.reorderall": "Reorder all",
  "label.requestcancellation": "Request Cancellation",
  "label.requestedamount": "Requested amount",
  "label.requesteddeliverydate": "Requested delivery date",
  "label.requesteddeliverydate.tooltip": "Please note that we cannot always guarantee your requested delivery date. Delivery is subject to availability and confirmation from our Brenntag team.",
  "label.requesteddeliverydate.warning": "Subject to availability and confirmation by Brenntag team.",
  "label.requesteddeliverydaterequired": "Requested delivery date is required",
  "label.requestquote": "Request quote",
  "label.retry": "Retry",
  "label.role": "Role",
  "label.role.Admin": "Admin",
  "label.role.CSR": "CSR",
  "label.role.ReadUser": "Read User",
  "label.role.SuperAdmin": "Super Admin",
  "label.role.User": "User",
  "label.role.UserAdmin": "User Admin",
  "label.role.UserManager": "User Manager",
  "label.salesorganisation": "Sales organisation",
  "label.scheduleddeliverydate": "Scheduled delivery date",
  "label.selectpaymentmethod": "Select your payment method",
  "label.selectsalesorganisation": "Select sales organisation",
  "label.shelflife": "Shelf life",
  "label.shippinginstructions": "Shipping instructions",
  "label.shipto": "Ship to",
  "label.shiptoaddress": "Ship-to address",
  "label.shiptoaddresses": "Ship-to address(es)",
  "label.shiptoaddressincorrect": "Ship-to selection is important as it enables correct pricing to be displayed by delivery locations. Please contact us via Chat if your Ship-to address is incorrect",
  "label.shiptoaddressrequired": "Ship-to address is required",
  "label.shoppingcart": "Shopping cart",
  "label.size": "Size",
  "label.soldtoaddress": "Sold-to address",
  "label.sortby": "Sort by",
  "label.specifications": "Specifications",
  "label.statusacknowledged": "Acknowledged",
  "label.statusclosed": "Closed",
  "label.statusopen": "Open",
  "label.storageconditions": "Storage conditions",
  "label.subtotal": "Subtotal",
  "label.tab.attachedfiles": "Attached files",
  "label.tab.attachnew": "Attach new",
  "label.tax": "Tax",
  "label.temperatureconditions": "Temperature conditions",
  "label.termsandconditions": "Terms and conditions",
  "label.timezone": "Time zone",
  "label.total": "Total",
  "label.type": "Type",
  "label.unitprice": "Unit price",
  "label.unnumber": "UN number",
  "label.updated": "Updated",
  "label.user": "User",
  "label.validfrom": "Valid from",
  "label.validto": "Valid to",
  "label.viewquote": "View quote",
  "label.viewvideos": "View How-to videos",
  "label.yes": "Yes",
  "label.yourproductnumber": "Your product number",
  "languageselection.modal.areyousure": "Are you sure you want to change your language?",
  "languageselection.modal.confirm": "Yes, change language",
  "languageselection.modal.description": "Changing your language will affect all your emails and every user interface in Brenntag Connect.",
  "languageselection.modal.title": "Change preferred language",
  "location.shipto.notavailable": "This product isn't available for your selected \nship-to-location. Select another location.",
  "logout.changeswillbelost": "The changes on this page will be lost if you log out.",
  "logout.confirmlogout": "Are you sure you want to continue?",
  "logout.itemsinyourshoppingcartcanbelost": "The items in your cart may be lost if you log out.",
  "message.accessrestricted": "It appears you do not have the access rights to do what you were trying to do. \nIf this is incorrect, please contact your administrator.",
  "message.admincsrredirect": "It appears you have elevated access rights and are in the wrong place!",
  "message.areyousure": "Are you sure?",
  "message.changesalesorg": "Changing sales organisation will affect your product catalog, order list, quotes, invoices and all the current items in shopping cart in Brenntag Connect. You will be able to change it back whenever you need.",
  "message.changeswillbelost": "The changes on this page will be lost.",
  "message.documentnotfound": "An error has been identified due to a duplicate or corrupt document, or the new document cannot be loaded.",
  "message.noitemstoshow": "Sorry, no items to show",
  "message.noprices": "Contact us via chat to request a price for this product",
  "message.pagenotfound": "This page seems to be missing",
  "message.productnaforshipto": "Ship-to is not available for requesting a quote. Select another one.",
  "order.cancelmodal.button": "Request order cancellation",
  "order.cancelmodal.question": "Are you sure you want to cancel the following order?",
  "order.cancelmodal.questionfollowup": "Once you confirm the cancellation request you will not be able to revert the action",
  "order.cancelmodal.title": "Request order cancellation",
  "order.cancelmodal.title.poabbr": "PO",
  "order.coadocument": "CoA document",
  "order.confirmationdocument": "Order confirmation",
  "order.history.batch": "Batch",
  "order.history.batch_amount": "Batch amount",
  "order.history.bill_to": "Bill to",
  "order.history.comment_from_user": "Comments",
  "order.history.deliveryNumber": "Delivery number",
  "order.history.delivery_date": "Delivery Date",
  "order.history.delivery_information": "Delivery information",
  "order.history.hide": "Hide",
  "order.history.missing_productname": "Product Name unavailable.",
  "order.history.nologs": "There are no logs for this order.",
  "order.history.number": "Number",
  "order.history.orderDetails": "Order Details",
  "order.history.orderStatus": "Order Status",
  "order.history.order_amount": "Order amount",
  "order.history.payment_terms": "Payment Terms",
  "order.history.pricing_unit_value": "Pricing unit value",
  "order.history.quantity_calculated": "Quantity calculated",
  "order.history.requested_delivery_date": "Requested delivery date",
  "order.history.ship_to": "Ship to",
  "order.history.shipping_instructions": "Shipping instructions",
  "order.history.show": "Show",
  "order.history.sold_to": "Sold to",
  "order.history.status": "Status",
  "order.history.subtotal_value": "Subtotal value",
  "order.history.title": "Order history log",
  "order.history.total_value": "Total value",
  "order.invoice.download": "Invoice download",
  "order.invoice.title": "Invoice",
  "order.invoice.titlePlural": "Invoices",
  "order.invoice.view": "View",
  "order.requestchange.allorderlinesdeleted": "Your order must have at least one Product to remain active. To cancel the order, please select ‘Request cancellation’ or contact us via chat.",
  "order.requestchange.close": "Close",
  "order.requestchange.closeeditmode": "Close edit mode",
  "order.requestchange.closeeditmodeconfirmation": "Yes, close edit mode",
  "order.requestchange.closewarning": "Are you sure you want to close the change request?",
  "order.requestchange.discardedwarning": "All the unsaved changes made to this order will be discarded and will not be considered.",
  "order.requestchange.leavewarning": "Are you sure you want to leave this page?",
  "order.requestchange.placechangerequest": "Place change request",
  "order.requestchange.productnotavailable": "Product or price is not available anymore for a change request, please contact us via chat.",
  "order.requestchange.requestchange": "Request Change",
  "order.requestchange.shiptoaddressnotavailable": "The ship-to address is not available for this order, please select another ship-to address or contact us via chat.",
  "order.requestchange.shiptoaddressnotavailablewarning": "Ship-to address not available",
  "order.status.Acknowledged": "Acknowledged",
  "order.status.Cancelled": "Cancelled",
  "order.status.Closed": "Closed",
  "order.status.Confirmed": "Confirmed",
  "order.status.Invoiced": "Invoiced",
  "order.status.Open": "Open",
  "order.status.OutForDelivery": "Scheduled for delivery",
  "order.status.Submitted": "Submitted",
  "order.success.message": "Your order is now with the Brenntag team for review. Once this review is complete you will receive a confirmation highlighting the details for delivery.\n\nShould you have any queries or would like to make any changes\nplease contact the Brenntag team via the chat.",
  "order.success.title": "Your order has been submitted",
  "page.AccessRestricted": "Access restricted",
  "page.CustomerList": "Customers",
  "page.Home": "Home",
  "page.InvoiceList": "Invoices",
  "page.NotFound": "Page not found (404)",
  "page.OrderList": "Orders",
  "page.PaymentInvoice": "Pay online",
  "page.ProductList": "Products",
  "page.Profile": "My profile",
  "page.QuoteList": "Quotes",
  "page.SearchResultsFor": "Search Results for",
  "page.TermsAndConditions": "Terms and conditions",
  "page.TermsOfUse": "Terms of Use - Brenntag Connect",
  "page.UserList": "Users",
  "paymentInvoice.error": "Your invoice could not be retrieved. Please refresh the page and try again.",
  "paymentInvoice.infoCard.credit": "Credit",
  "paymentInvoice.infoCard.creditcardStoreInfo": "Brenntag is not storing any credit card information of customers.",
  "paymentInvoice.infoCard.debitNote": "Debit note",
  "paymentInvoice.infoCard.downloadpdf": "Download PDF",
  "paymentInvoice.infoCard.invoice": "Invoice",
  "paymentInvoice.infoCard.price": "Price",
  "paymentInvoice.infoCard.review": "Click to review our",
  "paymentInvoice.infoCard.terms": "terms and conditions",
  "paymentRedirect.error.heading": "Something went wrong",
  "paymentRedirect.error.subtitle": "Please try again or contact us via chat.",
  "paymentRedirect.error.title": "There was an error during the payment and the invoice/debit note was not paid",
  "paymentRedirect.invoiceList": "Invoice list",
  "paymentRedirect.invoiceNumber": "Invoice Number",
  "paymentRedirect.paidAmount": "Paid Amount",
  "paymentRedirect.paymentReference": "Payment Reference",
  "paymentRedirect.pending.heading": "Pending confirmation",
  "paymentRedirect.pending.subtitle": "Once the payment is confirmed it will be processed by the Brenntag team and the status will be updated accordingly.",
  "paymentRedirect.pending.title": "Your payment is pending for a confirmation from the payment provider",
  "paymentRedirect.refused.heading": "Payment refused",
  "paymentRedirect.refused.subtitle": "Please try again using a different payment method.",
  "paymentRedirect.refused.title": "Your payment was refused and therefore unsuccessful",
  "paymentRedirect.success.heading": "Thank you",
  "paymentRedirect.success.subtitle": "Your invoice has been paid. The Brenntag team will process the payment and update the invoice status.",
  "paymentRedirect.success.title": "You have successfully paid and your request is being processed",
  "paymentterms.A001": "120 DAYS FROM INV DD, BY 15TH",
  "paymentterms.A002": "15 DAYS FROM INV DD, BY 25T",
  "paymentterms.A003": "15 DAYS FROM INV DD, BY 5TH",
  "paymentterms.A004": "30 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A005": "30 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A006": "30 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A007": "30 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A008": "45 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A009": "45 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A010": "60 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A011": "60 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A012": "60 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A013": "60 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A014": "75 DAYS FROM INV DATE, BY EOM",
  "paymentterms.A015": "90 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A016": "90 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A017": "90 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A018": "90 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A019": "60 DAYS FROM INV DATE, BY 26TH",
  "paymentterms.A020": "45 DAYS FROM INV DATE BY 10TH",
  "paymentterms.A021": "0-10:20,11-20:EoM,>=21 NxtM10",
  "paymentterms.A022": "INV 26-10:PAY 14,11-25: PAY 28",
  "paymentterms.A023": "CUT OFF 20TH, PAY ON 28TH",
  "paymentterms.A024": "45D FR INV;PAY 2ND/12TH/22ND",
  "paymentterms.A025": "45D (CUT-OFF 25TH) BY 15TH",
  "paymentterms.A026": "150D FROM INV DATE, PAY 25TH",
  "paymentterms.B004": "4 DAYS FROM INV DATE",
  "paymentterms.B005": "5 DAYS FROM INV DATE",
  "paymentterms.B007": "7 DAYS FROM INV DATE",
  "paymentterms.B009": "9 DAYS FROM INV DATE",
  "paymentterms.B010": "10 DAYS FROM INV DATE",
  "paymentterms.B013": "13 DAYS FROM INV DATE",
  "paymentterms.B014": "14 DAYS FROM INV DATE",
  "paymentterms.B015": "15 DAYS FROM INV DATE",
  "paymentterms.B018": "18 DAYS FROM INV DATE",
  "paymentterms.B020": "20 DAYS FROM INV. DATE",
  "paymentterms.B021": "21 DAYS FROM INV DATE",
  "paymentterms.B022": "22 DAYS FROM INV DATE",
  "paymentterms.B028": "28 DAYS FROM INV DATE",
  "paymentterms.B029": "29 DAYS FROM INV DATE",
  "paymentterms.B030": "30 DAYS FROM INV DATE",
  "paymentterms.B037": "37 DAYS FROM INV DATE",
  "paymentterms.B038": "38 DAYS FROM INV DATE",
  "paymentterms.B040": "40 DAYS FROM INV DATE",
  "paymentterms.B045": "45 DAYS FROM INV DATE",
  "paymentterms.B050": "50 DAYS FROM INV DATE",
  "paymentterms.B055": "55 DAYS FROM INV DATE",
  "paymentterms.B060": "60 DAYS FROM INV DATE",
  "paymentterms.B065": "65 DAYS FROM INV DATE",
  "paymentterms.B068": "68 DAYS FROM INV DATE",
  "paymentterms.B070": "70 DAYS FROM INV DATE",
  "paymentterms.B075": "75 DAYS FROM INV DATE",
  "paymentterms.B080": "80 DAYS FROM INV DATE",
  "paymentterms.B085": "85 DAYS FROM INV. DATE",
  "paymentterms.B090": "90 DAYS FROM INV DATE",
  "paymentterms.B105": "105 DAYS FROM INV DATE",
  "paymentterms.B120": "120 DAYS FROM INV DATE",
  "paymentterms.B150": "150 DAYS FROM INV DATE",
  "paymentterms.B180": "180 DAYS FROM INV DATE",
  "paymentterms.B360": "360 DAYS FROM INV DATE",
  "paymentterms.BA01": "50% ADV, BALANCE 30 DAYS INV",
  "paymentterms.BA02": "30% ADV, BALANCE 30 DAYS INV",
  "paymentterms.BA03": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA04": "30%TT ADV AND 70 % TT AT SIGHT",
  "paymentterms.BA05": "30%TT ADV AND 70 % DP AT SIGHT",
  "paymentterms.BA06": "80% TT ADV AND 20% TT AT SIGHT",
  "paymentterms.BA07": "20% TT ADV 80% DP AT SIGHT",
  "paymentterms.BA08": "28% TT ADV 72% 60D FR INV DATE",
  "paymentterms.BA09": "70% TT ADV 30% DP AT SIGHT",
  "paymentterms.BA10": "50% TT ADV 50% DP AT SIGHT",
  "paymentterms.BA11": "20% TT ADV 80% TT AT SIGHT",
  "paymentterms.BA12": "40% Advance, 60% B/L date",
  "paymentterms.BA13": "50% Advance, 50% BL date",
  "paymentterms.BA14": "50% ADV, BALANCE 45 DAYS INV",
  "paymentterms.BA15": "50% ADV BAL 45 DAYS BL DATE",
  "paymentterms.BA16": "50% TT ADV, 50 % LC AT SIGHT",
  "paymentterms.BA17": "50% ADV, 50% At SIGHT B/L COPY",
  "paymentterms.BA18": "70% TT ADV, 30% TT AT SIGHT",
  "paymentterms.BA19": "20% TT ADVANCE 80% COD",
  "paymentterms.BA20": "30% DP,70% after 60 days B/L",
  "paymentterms.BA21": "50% ADV, 50% AT SIGHT INV DATE",
  "paymentterms.BA22": "50% Advance 50% Immediate",
  "paymentterms.BA23": "70% TT AT SIGHT,30% TT 75 DAYS",
  "paymentterms.BA24": "50% TT ADV, 50% TT AT SIGHT",
  "paymentterms.BA25": "30% ADV, 70% BL DATE",
  "paymentterms.BA26": "10% DEP AGST PI, 90% TT@SIGHT",
  "paymentterms.BA27": "10% TT ADV, 90% DP AT SIGHT",
  "paymentterms.BA28": "15% TT ADV, 85% DP AT SIGHT",
  "paymentterms.BA29": "40% ADV, BAL COD",
  "paymentterms.BA30": "30% TT ADV, 70% 30D AFT B/L",
  "paymentterms.BA31": "90% CASH IN ADV, 10% TT 90DAYS",
  "paymentterms.BA32": "50% TT ADV, 50% TT 15D FR B/L",
  "paymentterms.BA33": "50% TT ADV, 50% 30D AFT B/L",
  "paymentterms.BA34": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA35": "50% ADV/50% 60DAYS FROM INVDAY",
  "paymentterms.BADV": "ADV PAYMENT",
  "paymentterms.BB05": "5 DAYS FROM BL DATE",
  "paymentterms.BB07": "7 DAYS FROM BL DATE",
  "paymentterms.BB10": "10 DAYS FROM BL DATE",
  "paymentterms.BB14": "14 DAYS FROM BL DATE",
  "paymentterms.BB15": "15 DAYS FROM BL DATE",
  "paymentterms.BB20": "20 DAYS FROM BL DATE",
  "paymentterms.BB21": "21 DAYS FROM BL DATE",
  "paymentterms.BB30": "30 DAYS FROM BL DATE",
  "paymentterms.BB35": "35 DAYS FROM BL DATE",
  "paymentterms.BB38": "38 DAYS FROM BL DATE",
  "paymentterms.BB40": "40 DAYS FROM BL DATE",
  "paymentterms.BB45": "45 DAYS FROM BL DATE",
  "paymentterms.BB46": "LC 45 DAYS FROM BL DATE",
  "paymentterms.BB50": "50 DAYS FROM BL DATE",
  "paymentterms.BB60": "60 DAYS FROM BL DATE",
  "paymentterms.BB65": "65 DAYS FROM BL DATE",
  "paymentterms.BB70": "70 DAYS FROM BL DATE",
  "paymentterms.BB75": "75 DAYS FROM BL DATE",
  "paymentterms.BB85": "85 DAYS FROM BL DATE",
  "paymentterms.BB90": "90 DAYS FROM BL DATE",
  "paymentterms.BB97": "97 DAYS FROM BL DATE",
  "paymentterms.BB98": "98 DAYS FROM BL DATE",
  "paymentterms.BB99": "99 DAYS FROM BL DATE",
  "paymentterms.BCBD": "CASH BEFORE DELIVERY",
  "paymentterms.BCOD": "CASH ON DELIVERY",
  "paymentterms.BD01": "D/A 15 DAYS FROM B/L DATE",
  "paymentterms.BD02": "D/A 30 DAYS FROM B/L DATE",
  "paymentterms.BD03": "D/A 45 DAYS FROM B/L DATE",
  "paymentterms.BD04": "D/A 60 DAYS FROM B/L DATE",
  "paymentterms.BD05": "D/A 75 DAYS FROM B/L DATE",
  "paymentterms.BD06": "D/A 90 DAYS FROM B/L DATE",
  "paymentterms.BD07": "D/A 120 DAYS FROM B/L DATE",
  "paymentterms.BD12": "DOC AGNST ACCEPTANCE 120 DAYS",
  "paymentterms.BD15": "DOC AGNST ACCEPTANCE 15 DAYS",
  "paymentterms.BD30": "DOC AGNST ACCEPTANCE 30 DAYS",
  "paymentterms.BD45": "DOC AGNST ACCEPTANCE 45 DAYS",
  "paymentterms.BD60": "DOC AGNST ACCEPTANCE 60 DAYS",
  "paymentterms.BD75": "DOC AGNST ACCEPTANCE 75 DAYS",
  "paymentterms.BD90": "DOC AGNST ACCEPTANCE 90 DAYS",
  "paymentterms.BDAA": "DOCUMENTS AGNST ACCEPTANCE",
  "paymentterms.BDAP": "DOC AGNST ACCEPTANCE AT SIGHT",
  "paymentterms.BE00": "0 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.BE14": "15 DAYS FR INV DD, EOM BY 20TH",
  "paymentterms.BE15": "15 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE16": "15 DAYS EOM",
  "paymentterms.BE20": "20DAYS FR INV DD, EOM BY 20TH",
  "paymentterms.BE21": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE22": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE23": "20 DAYS EOM BY 25TH",
  "paymentterms.BE30": "30 DAYS EOM BY 20TH",
  "paymentterms.BE31": "EOM BY 25TH",
  "paymentterms.BE32": "32 days end of month by 2nd",
  "paymentterms.BE33": "60 days end of month by 2nd",
  "paymentterms.BE45": "45 DAYS EOM",
  "paymentterms.BE60": "60 DAYS EOM",
  "paymentterms.BE61": "60 DAYS EOM BY 20TH",
  "paymentterms.BE62": "60 DAYS EOM BY 15TH",
  "paymentterms.BE63": "60 days end of month by 4th",
  "paymentterms.BE90": "90 DAYS EOM",
  "paymentterms.BE91": "90 DAYS EOM BY 5TH",
  "paymentterms.BIMM": "IMMEDIATE",
  "paymentterms.BL15": "LC 15 DAYS AT SIGHT",
  "paymentterms.BL21": "LC 21 DAYS AT SIGHT",
  "paymentterms.BL30": "LC 30 DAYS AT SIGHT",
  "paymentterms.BL45": "LC 45 DAYS AT SIGHT",
  "paymentterms.BL60": "LC 60 DAYS AT SIGHT",
  "paymentterms.BL61": "LC 60 DAYS BL",
  "paymentterms.BL75": "LC 75 DAYS AT SIGHT",
  "paymentterms.BL90": "LC 90 DAYS AT SIGHT",
  "paymentterms.BL91": "LC 90 DAYS BL",
  "paymentterms.BLAS": "LC PAYMENT AT SIGHT",
  "paymentterms.BP12": "DOCUMENTS AGNST PAYTS 120 DAYS",
  "paymentterms.BP30": "DOCUMENTS AGNST PAYTS 30 DAYS",
  "paymentterms.BP60": "DOCUMENTS AGNST PAYTS 60 DAYS",
  "paymentterms.BPAA": "D/P AT SIGHT",
  "paymentterms.BTAS": "TT AT SIGHT",
  "paymentterms.CAD1": "CASH AGAINST DOCUMENT",
  "paymentterms.CBO1": "CBO",
  "paymentterms.CBO2": "30% CBO, 70% CBD",
  "paymentterms.CBO3": "50% CBO, 50% CBD",
  "paymentterms.CBO4": "50% CBO, 50% COD",
  "paymentterms.CBO5": "50% CBO, 50% 30 DAYS FROM INV",
  "paymentterms.CNMT": "CNMT - CONSIGNMENT",
  "paymentterms.D001": "TT AGAINST DOCUMENT",
  "paymentterms.D002": "TT IN ADVANCE",
  "paymentterms.D004": "TT EOM 30D BY 20TH FRM BL DD",
  "paymentterms.D005": "TT 30 DAYS FROM INVOICE DATE",
  "paymentterms.D006": "TT 45 DAYS FROM BL DATE",
  "paymentterms.D007": "TT 45 DAYS FROM INV DATE",
  "paymentterms.D008": "TT 60 DAYS FROM INVOICE DATE",
  "paymentterms.D010": "TT 65 DAYS FROM  B/L Date",
  "paymentterms.D011": "TT 25 DAYS FROM INVOICE DATE",
  "paymentterms.D012": "TT AGAINST BL",
  "paymentterms.D013": "7 DAYS T/T AT SIGHT",
  "paymentterms.D014": "T/T BEFORE DELIVERY",
  "paymentterms.D015": "TT UPON ORDER CONFIRMATION",
  "paymentterms.D016": "TT 2 DAYS FROM INVOICE DATE",
  "paymentterms.D017": "TT 90 DAYS FROM INVOICE DATE",
  "paymentterms.DD01": "DIRECT DEBIT 30 DAYS",
  "paymentterms.DD02": "DIRECT DEBIT 60 DAYS",
  "paymentterms.DD03": "DIRECT DEBIT 90 DAYS",
  "paymentterms.E001": "EOM 30 DAYS BY 10TH",
  "paymentterms.E002": "EOM 30 DAYS BY 15TH",
  "paymentterms.E003": "EOM 30 DAYS BY 20TH",
  "paymentterms.E004": "EOM 30 DAYS BY 25TH",
  "paymentterms.E005": "EOM 60 DAYS BY 10TH",
  "paymentterms.E006": "EOM 60 DAYS BY 15TH",
  "paymentterms.E007": "EOM 60 DAYS BY 20TH",
  "paymentterms.E008": "EOM 60 DAYS BY 25TH",
  "paymentterms.E009": "EOM 90 DAYS BY 10TH",
  "paymentterms.E010": "EOM 90 DAYS BY 15TH",
  "paymentterms.E011": "EOM 90 DAYS BY 20TH",
  "paymentterms.E012": "EOM 90 DAYS BY 25TH",
  "paymentterms.E013": "EOM",
  "paymentterms.E014": "EOM 30 DAYS",
  "paymentterms.E015": "EOM 30 DAYS BY 5th",
  "paymentterms.E016": "EOM 30 DAYS BY 10th",
  "paymentterms.E017": "EOM 30D BY 20th",
  "paymentterms.E018": "EOM 30D BY 25th",
  "paymentterms.E019": "EOM 30 DAYS (CUT-OFF 25th)",
  "paymentterms.E020": "EOM 30D (CUT-OFF 25th) BY 5TH",
  "paymentterms.E021": "EOM 30D (CUT-OFF 25th) BY 10TH",
  "paymentterms.E022": "EOM 45 DAYS (CUT-OFF 25th)",
  "paymentterms.E023": "EOM 60 DAYS",
  "paymentterms.E024": "EOM 60 DAYS BY 5th",
  "paymentterms.E025": "EOM 60 DAYS BY 10th",
  "paymentterms.E026": "EOM 60 DAYS BY 15th",
  "paymentterms.E027": "EOM 60 DAYS (CUT-OFF 25th)",
  "paymentterms.E028": "EOM 60D (CUT-OFF 25th) BY 5TH",
  "paymentterms.E029": "EOM 60D (CUT-OFF 25th) BY 10TH",
  "paymentterms.E030": "EOM 90 DAYS",
  "paymentterms.E031": "EOM 90 DAYS BY 7TH",
  "paymentterms.E032": "EOM 90 DAYS (CUT-OFF 20th)",
  "paymentterms.E033": "EOM 90 DAYS (CUT-OFF 25th)",
  "paymentterms.E034": "EOM BY 5TH",
  "paymentterms.E035": "EOM BY 10TH",
  "paymentterms.E036": "EOM 30D (CUT-OFF 20th) BY 15TH",
  "paymentterms.E037": "EOM 90D (CUT-OFF 25th) by 7th",
  "paymentterms.E038": "EOM 45 DAYS (CUT-OFF 25) BY 5",
  "paymentterms.E039": "EOM 60 DAYS (CUT-OFF 20th)",
  "paymentterms.E040": "EOM 90 DAYS (CUT-OFF 25) BY 8",
  "paymentterms.E041": "EOM 60 DAYS (CUT-OFF 25th) 15",
  "paymentterms.E042": "EOM 90 DAYS (CUT-OFF 25th) 5th",
  "paymentterms.E043": "EOM 90 DAYS (CUT-OFF 25th) 10",
  "paymentterms.E044": "EOM 90 DAYS (CUT-OFF 25th)15",
  "paymentterms.E045": "EOM 90 DAYS (CUT-OFF 25th)20th",
  "paymentterms.E046": "EOM 120 DAYS(CUT-OFF 25th)15th",
  "paymentterms.E047": "EOM 30 DAYS (CUT-OFF 25th)15th",
  "paymentterms.E048": "DUE SAME DAY NEXT MTH",
  "paymentterms.E049": "EOM 30 DAYS (DUE ON 27TH)",
  "paymentterms.E050": "EOM 60 DAYS DUE 25th",
  "paymentterms.E051": "EOM 210D",
  "paymentterms.E052": "EOM 105D",
  "paymentterms.E053": "EOM 60 DAYS (CUT-OFF 20TH) 20",
  "paymentterms.E054": "EOM 30 DAYS (CUT-OFF  20th)",
  "paymentterms.E055": "EOM 30D (CUT_OFF 25TH) BY 16TH",
  "paymentterms.E056": "EOM 85D (CUT-OFF 25TH)",
  "paymentterms.E057": "EOM 90D (DUE 5TH FOLLOWING)",
  "paymentterms.E058": "EOM 120D",
  "paymentterms.E059": "EOM (CUT-OFF 25TH) BY 5TH",
  "paymentterms.E060": "EOM 45 DAYS BY 15TH",
  "paymentterms.E061": "64 DAYS FROM EOM",
  "paymentterms.E062": "EOM BY 10TH",
  "paymentterms.E063": "EOM BY 26TH",
  "paymentterms.E064": "EOM 31 days",
  "paymentterms.E065": "EOM 50 DAYS (CUT-OFF 24th)",
  "paymentterms.E120": "120 DAYS EOM",
  "paymentterms.EA65": "65 DAYS ETA",
  "paymentterms.EM15": "EOM 15 DAYS",
  "paymentterms.EM20": "EOM 20 DAYS",
  "paymentterms.EM30": "30 DAYS EOM",
  "paymentterms.EM45": "EOM 45 DAYS",
  "paymentterms.EM65": "EOM 65 DAYS",
  "paymentterms.EM75": "EOM 75 DAYS",
  "paymentterms.EQ01": "End of Quarter (by 20th)",
  "paymentterms.GR10": "10 DAYS AFTER GOODS RECEIPT",
  "paymentterms.GR30": "30 DAYS AFTER GOODS RECEIPT",
  "paymentterms.IK00": "Within 5 days 3% cash discount",
  "paymentterms.L001": "LC 150 DAYS AT SIGHT",
  "paymentterms.L002": "LC 180 DAYS AT SIGHT",
  "paymentterms.L003": "LC 105 DAYS BL",
  "paymentterms.L004": "LC 120 DAYS BL",
  "paymentterms.L005": "LC 150 DAYS BL",
  "paymentterms.L006": "LC 180 DAYS BL",
  "paymentterms.L007": "LC 15 DAYS BL",
  "paymentterms.L030": "LC 30 DAYS BL",
  "paymentterms.L105": "105 DAYS FROM BL DATE",
  "paymentterms.L120": "120 DAYS FROM BL DATE",
  "paymentterms.L150": "150 DAYS FROM BL DATE",
  "paymentterms.L180": "L 180 DAYS FROM BL DATE",
  "paymentterms.LD01": "LAST DAY NEXT MTH",
  "paymentterms.LD02": "LAST DAY OF MTH AFT NEXT MTH",
  "paymentterms.LD03": "LAST DAY OF THREE MONTH LATER",
  "paymentterms.LVT0": "16 days 2%, 31 days net",
  "paymentterms.M001": "3 MONTH LATER BY 5TH",
  "paymentterms.M002": "3 MONTH LATER BY 5TH",
  "paymentterms.MVT0": "10 days 3%, 16  2%, 31 net",
  "paymentterms.P001": "60 DAYS ETA",
  "paymentterms.P002": "90 DAYS ETA",
  "paymentterms.P003": "15 DAYS FROM ETA HCM PORT",
  "paymentterms.P004": "60 DAYS FROM ETA, PAY ON 26TH",
  "paymentterms.PBD1": "PDC BEFORE DEL 30 DAYS",
  "paymentterms.PBD2": "PDC BEFORE DEL 45 DAYS",
  "paymentterms.PBD3": "PDC BEFORE DEL 60 DAYS",
  "paymentterms.PBD4": "PDC BEFORE DEL 90DAYS FROM INV",
  "paymentterms.PBD5": "PDC BEFORE DEL 15 DAYS",
  "paymentterms.PDC1": "30 DAYS PDC FROM INV DATE",
  "paymentterms.PDC2": "60 DAYS PDC FROM INV DATE",
  "paymentterms.PDC3": "45 DAYS PDC FROM INV DATE",
  "paymentterms.PDC4": "15 DAYS PDC FROM INV DATE",
  "paymentterms.PDC5": "90 DAYS PDC FROM INV DATE",
  "paymentterms.PUD1": "PDC UPON DEL 15 DAYS FROM INV",
  "paymentterms.PUD2": "PDC UPON DEL 30 DAYS FROM INV",
  "paymentterms.PUD3": "PDC UPON DEL 45 DAYS FROM INV",
  "paymentterms.PUD4": "PDC UPON DEL 60 DAYS FROM INV",
  "paymentterms.PUD5": "PDC UPON DEL 90 DAYS FROM INV",
  "paymentterms.TX07": "7 DAYS AFTER STOCK ARRIVAL",
  "paymentterms.TX30": "30 DAYS DECLARATION",
  "paymentterms.TX45": "45 DAYS DECLARATION",
  "paymentterms.TX60": "60 DAYS DECLARATION",
  "paymentterms.TX90": "90 DAYS DECLARATION",
  "paymentterms.WALL": "99% forever",
  "paymentterms.WL01": "12 days net",
  "paymentterms.Z001": "custom payment term (test)",
  "paymentterms.ZB00": "Pay immediately w/o deduction",
  "paymentterms.ZB01": "14 Days 3%, 30/2%, 45 net",
  "paymentterms.ZB02": "8 days 5%, 14/2%, 21 net",
  "paymentterms.ZB03": "20 days 2%, 30 days net",
  "paymentterms.ZB04": "10 days 4%, 20/2%, 30 net",
  "paymentterms.ZB05": "5 days 2%, 10 days net",
  "phone.landline": "Landline phone",
  "phone.mobile": "Mobile phone",
  "product.altsizes.loadmore": "Load more alternative sizes",
  "product.discount.saveamount": "Save @@AMOUNT@@",
  "product.discount.savingspercentage": "@@PERCENTAGE@@ Savings",
  "product.documentType.msds": "SDS Document",
  "product.documentType.tds": "TDS Document",
  "product.documenterror": "Could not retrieve documents",
  "product.loadingdocuments": "Loading documents",
  "product.nodocuments": "No documents available",
  "product.safetyinformation": "Safety information",
  "product.type.nonvaluated": "Non-Valuated Materials",
  "product.type.packaging": "Packaging",
  "product.type.returnable": "Returnable package",
  "product.type.sample": "Sample",
  "product.type.services": "Services",
  "product.type.tolling": "Tolling",
  "product.type.tolling-raw-material-nonvaluated": "Tolling raw material non-valuated",
  "product.type.tradinggoods": "Trading goods",
  "quote.date": "Quote date",
  "quote.decline": "Decline quote",
  "quote.details": "Quote details",
  "quote.number": "Quote number",
  "quote.requoteproduct": "Requote product",
  "quote.validfrom": "Valid from",
  "quote.validto": "Valid to",
  "quote.value": "Quote value",
  "quotestatus.Declined": "Declined",
  "quotestatus.Expired": "Expired",
  "quotestatus.InProgress": "In progress",
  "quotestatus.Open": "Open",
  "quotestatus.Ordered": "Ordered",
  "quotestatus.Submitted": "Submitted",
  "quotestatus.Upcoming": "Upcoming",
  "regex.placeordertermsandconditions": "By placing an order you accept our @@TERMS_AND_CONDITIONS@@",
  "regex.reviewtermsandconditions": "Click here to review our @@TERMS_AND_CONDITIONS@@",
  "requestcancellation.request": "Brenntag Customer Service Team, I would like to request cancellation of the order with order number: @@ORDER_NUMBER@@ and customer number: @@CUSTOMER_NUMBER@@. Please provide confirmation or further information as required.",
  "requestchanges.message.billToAddress": "- Previous billing address:\n@@LOCATION_OLD@@\n\n- New billing address:\n@@LOCATION_NEW@@\n",
  "requestchanges.message.cancelproduct": "- Cancel this product:\n\nProduct: @@PRODUCT_NAME@@\nProduct ID: @@PRODUCT_NUMBER@@\n",
  "requestchanges.message.comments": "- Comments:\n@@COMMENTS_OLD@@ → @@COMMENTS_NEW@@\n",
  "requestchanges.message.deliverydate": "- Requested delivery date:\n@@DATE_OLD@@ → @@DATE_NEW@@\n",
  "requestchanges.message.heading": "Brenntag Customer Service Team, can you please change the following information for my order:\n\nCustomer number @@CUSTOMER_NUMBER@@\nOrder number @@PURCHASE_ORDER_NUMBER@@\n\n---------\n",
  "requestchanges.message.orderline": "- Change this product:\n\nProduct: @@PRODUCT_NAME@@\nProduct ID: @@PRODUCT_NUMBER@@\n- Quantity: @@QUANTITY_OLD@@ → @@QUANTITY_NEW@@\n- Amount: @@AMOUNT_OLD@@ @@AMOUNT_UOM_OLD@@ → @@AMOUNT_NEW@@ @@AMOUNT_UOM_NEW@@\n",
  "requestchanges.message.shipToAddress": "- Previous delivery address:\n@@LOCATION_OLD@@\n\n- New delivery address:\n@@LOCATION_NEW@@\n",
  "requestquote.request": "Brenntag Customer Service Team, please provide a quote for the following:\n\nCustomer number @@CUSTOMER_NUMBER@@\n\nProduct: @@PRODUCT_NAME@@\n\nProduct ID: @@PRODUCT_NUMBER@@\n\nRequested quantity: @@QUANTITY@@\n\nRequested amount: @@REQUESTED_AMOUNT@@\n\nDelivery address:\n@@SHIP_TO_ADDRESS@@\n\nRequested Delivery Date: @@REQUESTED_DELIVERY_DATE@@",
  "show_more.less": "Show less",
  "show_more.more": "Show more",
  "show_more.results": "Show more results",
  "something.wrong": "Oops! Something went wrong. Please try again",
  "something.wrong.documents": "Oops! Something went wrong",
  "sortinglabel.-currency": "Currency (Z-A)",
  "sortinglabel.-customerName": "Customer name (Z-A)",
  "sortinglabel.-dueDate": "Due date newest",
  "sortinglabel.-grossAmount.amount": "Amount due highest",
  "sortinglabel.-invoiceNumber": "Invoice number (Z-A)",
  "sortinglabel.-issueDate": "Date issued newest",
  "sortinglabel.-lastLoggedInAt": "Last login newest ",
  "sortinglabel.-lastUpdateDate": "Updated newest",
  "sortinglabel.-name": "Product name (Z-A)",
  "sortinglabel.-netAmount": "Net amount highest",
  "sortinglabel.-orderCreationDate": "Order date newest",
  "sortinglabel.-packaging.name": "Pack type (Z-A)",
  "sortinglabel.-quoteCreationDate": "Quote date newest",
  "sortinglabel.-username": "Name (Z-A)",
  "sortinglabel.-usertype": "User type (External first)",
  "sortinglabel.currency": "Currency (A-Z)",
  "sortinglabel.customerName": "Customer name (A-Z)",
  "sortinglabel.dueDate": "Due date oldest",
  "sortinglabel.grossAmount.amount": "Amount due lowest",
  "sortinglabel.invoiceNumber": "Invoice number (A-Z)",
  "sortinglabel.issueDate": "Date issued oldest",
  "sortinglabel.lastLoggedInAt": "Last login oldest ",
  "sortinglabel.lastUpdateDate": "Updated oldest",
  "sortinglabel.name": "Product name (A-Z)",
  "sortinglabel.netAmount": "Net amount lowest",
  "sortinglabel.orderCreationDate": "Order date oldest",
  "sortinglabel.packaging.name": "Pack type (A-Z)",
  "sortinglabel.quoteCreationDate": "Quote date oldest",
  "sortinglabel.relevance": "Relevance",
  "sortinglabel.username": "Name (A-Z)",
  "sortinglabel.usertype": "User type (Internal first)",
  "storageconditions.01": "General Storage-Food, Pharma",
  "storageconditions.02": "General Storage",
  "storageconditions.03": "Hazardous Storage",
  "storageconditions.04": "Cool Room Storage Food, Pharma",
  "storageconditions.05": "Flammable Ambient",
  "storageconditions.06": "Cool Room Storage",
  "storageconditions.07": "Freezer Room Storage",
  "storageconditions.08": "Flurochemical Storage",
  "storageconditions.09": "Ammonia Storage",
  "storageconditions.10": "Non-conforming Storage",
  "storageconditions.11": "Liquid Bulk Storage",
  "storageconditions.12": "Production Area",
  "support.email": "support@brenntagconnect.com",
  "support.email.salesgroup.NL01": "orders.au@brenntag-asia.com",
  "support.email.topic": "Enquiry: {customer PO#}/ {quotation #}/ {customer ID}",
  "support.phonenumber": "+123 3453 043",
  "temperatureconditions.01": ">25 to 40ºC",
  "temperatureconditions.02": ">15 to 25ºC with controlled humidity",
  "temperatureconditions.03": ">8 to 15ºC with controlled humidity",
  "temperatureconditions.04": ">0 to 8ºC with controlled humidity",
  "temperatureconditions.05": ">-20 to 0ºC",
  "temperatureconditions.06": "-20ºC & below",
  "terms.agree": "Yes, I agree",
  "terms.description": "By accessing or using any part of Brenntag Connect, you agree to be bound by these Terms of Use.\n\nIf you do not agree to all the terms and conditions of this agreement, you can not access Brenntag Connect or use any of its services",
  "terms.disagree": "No, log out",
  "timeunit.many.day": "days",
  "timeunit.many.month": "months",
  "timeunit.many.week": "weeks",
  "timeunit.many.year": "years",
  "timeunit.one.day": "day",
  "timeunit.one.month": "month",
  "timeunit.one.week": "week",
  "timeunit.one.year": "year",
  "toast.error.coadocuments": "Something went wrong retrieving CoA documents",
  "toast.error.createuser": "Something went wrong creating the user",
  "toast.error.customernotfound": "Something went wrong. Please contact Brenntag Connect.",
  "toast.error.customers": "Something went wrong retrieving customers",
  "toast.error.invoices": "Something went wrong retrieving invoice data",
  "toast.error.languagechange": "Language change failed",
  "toast.error.orderdetails": "Something went wrong retrieving order details",
  "toast.error.orders": "Something went wrong retrieving order history",
  "toast.error.placingorder": "Something went wrong placing the order",
  "toast.error.price": "Something went wrong retrieving price",
  "toast.error.productdocuments": "Something went wrong retrieving product documents",
  "toast.error.products": "Something went wrong retrieving product data",
  "toast.error.quote": "Something went wrong retrieving quote details",
  "toast.error.quotereject": "Something went wrong rejecting quote",
  "toast.error.quotes": "Something went wrong retrieving quotes",
  "toast.error.saveuser": "Something went wrong saving user changes",
  "toast.error.userinfo": "Something went wrong retrieving user information",
  "toast.error.userservice": "Something went wrong retrieving user data",
  "toast.error.userservice.emailaddressexists": "User with email address @@EMAIL@@ already exists",
  "toast.error.userservice.permissionsoutsidesalesgroup": "You cannot create or modify a user which is outside of the sales group assigned to you",
  "toast.error.userservice.savefailed": "Something went wrong saving user data",
  "toast.error.validatingcart": "Something went wrong validating cart",
  "toast.success.createuser": "User @@USER@@ created successfully",
  "toast.success.deleteuser": "User @@USER@@ deleted successfully",
  "toast.success.resetpassword": "We've just sent you an email at @@EMAIL@@ to reset your password.",
  "toast.success.saveuser": "User @@USER@@ saved successfully",
  "user.accessrights": "Access rights and Language",
  "user.accessrights.message": "Assign access rights to a customer",
  "user.bcaccessstatus": "Brenntag Connect access status",
  "user.create": "Create user",
  "user.createdon": "Created on",
  "user.delete.confirmation": "This cannot be undone, continue?",
  "user.delete.message": "The user @@USER@@ will be irreversibly deleted from the system.",
  "user.edit": "Edit user",
  "user.information": "User information",
  "user.lastpasswordreset": "Last password reset",
  "user.modal.terminate.confirmation": "Are you sure you want to terminate this user?",
  "user.modal.terminate.message": "Warning: A terminated user will no longer be able to login to Brenntag Connect.",
  "user.notes": "Notes",
  "user.notes.placeholder": "Example: info on working hours, backup contact",
  "user.role": "Role",
  "user.save": "Save changes",
  "user.search.customer": "Search Customer number or name",
  "user.selectcustomer": "Select customers",
  "user.selectlanguage": "Select language",
  "user.view": "View user",
  "userEdit.cancel.confirm": "Are you sure you wish to cancel?",
  "userEdit.cancel.create.external": "Cancel 'create external user'",
  "userEdit.cancel.create.internal": "Cancel 'create internal user'",
  "userEdit.cancel.edit.external": "Cancel 'edit external user'",
  "userEdit.cancel.edit.internal": "Cancel 'edit internal user'",
  "userEdit.message.cannotedit": "You cannot edit the user details for this user. Please contact Brenntag, if you wish to edit this user.",
  "userrole.Admin": "Admin",
  "userrole.CSR": "CSR",
  "userrole.ReadUser": "Read-only User",
  "userrole.SuperAdmin": "Super Administrator",
  "userrole.User": "User",
  "userrole.UserAdmin": "User Administrator",
  "userrole.UserManager": "User Manager",
  "userrole.description": "User role",
  "validationerror.invalid-date": "The selected date is invalid",
  "validationerror.invalid-moq": "The selected amount is below the minimum order quantity",
  "validationerror.not-authorized": "Not authorized",
  "validationerror.not-found": "This product does not exist",
  "validationerror.price-changed": "The price for this product has been updated",
  "validationerror.price-mismatch": "Some of the prices have been updated",
  "validationerror.price-not-found": "Price not found for this product. Please contact us via Chat to request a price.",
  "validationerror.uom-mismatch": "The UOM of this product does not match",
  "video.invoices": "Invoices",
  "video.invoices.description": "Learn how to locate and download invoices",
  "video.ordering": "Ordering and Reordering",
  "video.ordering.description": "Learn how to order and reorder products",
  "video.orderlist": "View Order List",
  "video.orderlist.description": "Learn about your order list and order history",
  "video.productsearch": "Product Search",
  "video.productsearch.description": "Learn how to search for products and view product details"
} as const
